import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { InputValidators, NameValidators } from '@shared/utils/form_validators.util';

@Component({
  selector: 'app-personal-details-form',
  imports: [MatFormField, MatLabel, MatError, CommonModule, ReactiveFormsModule, MatInput],
  templateUrl: './personal-details-form.html',
  styleUrl: './personal-details-form.scss',
  standalone: true,
})
export class PersonalDetailsForm implements OnInit {
  constructor(private _formBuilder: FormBuilder) {}

  @Output() formChange = new EventEmitter<FormGroup>();
  personalDetailsForm = signal<FormGroup>(this._formBuilder.group({}));

  ngOnInit(): void {
    this.setupDetailsForm();
  }

  setupDetailsForm() {
    const form = this._formBuilder.group(
      {
        firstName: [
          '',
          [
            Validators.required,
            InputValidators.alphabetInputOnlyValidator(),
            NameValidators.noSingleCharacter,
            NameValidators.noConsecutiveRepeats,
            NameValidators.mustContainVowelsIfLengthMoreThanTwo,
          ],
        ],
        lastName: [
          '',

          [
            Validators.required,
            InputValidators.alphabetInputOnlyValidator(),
            NameValidators.noSingleCharacter,
            NameValidators.noConsecutiveRepeats,
            NameValidators.mustContainVowels,
          ],
        ],
      },
      {
        validators: NameValidators.noIdenticalNames('firstName', 'lastName'), // Cross-field validation
      }
    );

    this.personalDetailsForm.set(form);
    this.formChange.emit(this.personalDetailsForm());
  }
}
